import { ModalForm } from './modal-form';
import { ModalHeader } from './modal-header';
import { VHCRecordLogInput } from 'api/generated';
import { FC, useEffect } from 'react';

type Props = {
  id: number;
  onClose: (isReload?: boolean) => void;
  branchId?: number;
  cdkVehicleId?: string;
} & VHCRecordLogInput;

export const EditMileageModal: FC<Props> = (props) => {
  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  return (
    <>
      <div className="modal fade show d-block" id="kt_modal" role="dialog" tabIndex={-1} aria-modal="true">
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered modal-md">
          {/* begin::Modal content */}
          <div className="modal-content">
            <ModalHeader {...props} />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y pb-8 pt-0">
              <ModalForm {...props} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};
